<template>
    <div class="p-fluid formgrid grid mt-10">
        <div class="field col-12 md:col-6">
            <label for="nik">{{ $t('employee-number') }} *</label>
            <InputText id="nik" type="text" v-model="form.nik" placeholder="ex. 2022.01" :class="{
                'p-invalid':
                    submitted && !form.nik,
            }" />
            <small class="p-invalid" v-if="submitted && !form.nik"
                >{{ $t('employee-number') }} is required.</small
            >
        </div>
        <div class="field col-12 md:col-6">
            <label for="idcard">{{ $t('id-card-number') }}</label>
            <InputText id="idcard" type="text" v-model="form.id_card_number" :disabled="true"/>
        </div>
        <div class="field col-12">
            <label for="name">{{ $t('name') }}</label>
            <InputText id="name" type="text" v-model="form.name" :disabled="true"/>
        </div>
        <div class="field col-12 md:col-4">
            <label for="birthplace">{{ $t('birthplace') }}</label>
            <InputText id="birthplace" type="text" v-model="form.birthplace" :disabled="true"/>
        </div>
        <div class="field col-12 md:col-4">
            <label for="birthdate">{{ $t('birthdate') }}</label>
            <InputText id="birthdate" type="text" v-model="form.birthdate" :disabled="true"/>
        </div>
        <div class="field col-12 md:col-4">
            <label for="gender">{{ $t('gender') }}</label>
            <Dropdown v-model="form.gender" :options="genders" placeholder="Select Gender" :disabled="true" option-label="name" option-value="code"></Dropdown>
        </div>
        <div class="field col-12 md:col-4">
            <label for="blood_type">{{ $t('blood-type') }}</label>
            <Dropdown v-model="form.blood_type" :options="blood_types" placeholder="Select Blood Type" :disabled="true"></Dropdown>
        </div>
        <div class="field col-12 md:col-6">
            <label for="last_formal_education">{{ $t('last-education') }}</label>
            <Dropdown v-model="form.last_formal_education" :options="educations" placeholder="Select Education" :disabled="true" optionLabel="name" optionValue="id"></Dropdown>
        </div>
        <div class="field col-12 md:col-2">
            <label for="gpa">{{ $t('gpa') }}</label>
            <InputText id="gpa" type="text" v-model="form.gpa" :disabled="true"/>
        </div>
        <div class="field col-12 md:col-2">
            <label for="religion">{{ $t('religion') }}</label>
            <Dropdown v-model="form.religion" :options="religions" placeholder="Select Religion" :disabled="true"></Dropdown>
        </div>
        <div class="field col-12 md:col-2">
            <label for="nationality">{{ $t('nationality') }}</label>
            <Dropdown v-model="form.nationality" :options="nationalities" placeholder="Select Nationalities" :disabled="true"></Dropdown>
        </div>
        <div class="field col-12 md:col-6">
            <label for="clan">{{ $t('clan') }}</label>
            <InputText id="clan" type="text" v-model="form.clan" :disabled="true"/>
        </div>
        <div class="field col-12 md:col-2">
            <label for="marital_status">{{ $t('marital-status') }}</label>
            <Dropdown v-model="form.marital_status" :options="marital_statuses" placeholder="Select Marital Status" :disabled="true"></Dropdown>
        </div>
        <div class="field col-12 md:col-4">
            <label for="telephone_number">{{ $t('telephone-number') }}</label>
            <InputText id="telephone_number" type="text" v-model="form.telephone_number" :disabled="true"/>
        </div>
        <div class="field col-12 md:col-4">
            <label for="phone_number">{{ $t('phone-number') }}</label>
            <InputText id="phone_number" type="text" v-model="form.phone_number" :disabled="true"/>
        </div>
        <div class="field col-12 md:col-4">
            <label for="email">{{ $t('email') }}</label>
            <InputText id="email" type="text" v-model="form.email" :disabled="true"/>
        </div>
        <div class="field col-12">
            <label for="address">{{ $t('address') }}</label>
            <Textarea id="address" rows="4" v-model="form.address" :disabled="true"/>
        </div>
    </div>
    <div class="grid formgrid right-0">
        <div class="col-6">
            <div v-if="(form.foto != 'none' || !form.foto)" class="field col-12">
                <Image
                    :src="form.foto"
                    preview="true"
                    width="250"
                />
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import Image from 'primevue/image';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Textarea from 'primevue/textarea';

export default {
    components: {InputText, Image, Dropdown, Textarea, TabView, TabPanel, Button},
    props:['submitted'],
    data(){
        return{
            form: this.$page.props.candidate.data,
            genders: [
                {name: 'Laki-Laki', code: 'Laki-laki'},
                {name: 'Perempuan', code: 'Perempuan'},
            ],
            blood_types: ["A", "B", "O", "AB"],
            educations: "",
            religions: ['Islam','Katolik','Kristen','Hindu','Budha'],
            nationalities: "",
            marital_statuses: ['married','single','widow'],
        }
    },
    mounted(){
        this.initData();
    },
    methods: {
        initData(){
            axios.get(`${this.$page.props.appUrl}api/education-levels`)
            .then((data) => {
                this.educations = data.data.data
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "education level : " . error,
                    life: 3000,
                });
            });

            axios.get(`${this.$page.props.appUrl}api/nationalities`)
            .then((data) => {
                this.nationalities = data.data.data
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: error,
                    life: 3000,
                });
            });
        }
    }
}
</script>
